import React from 'react';
import BuildActions from '../builder/action/builderActions';
import { findIndex } from 'underscore';
import clone from 'clone';

class SearchPanel extends React.Component {
  constructor(props) {
    super(props);
    this.searchComponents = [
      {
        icon: 'ion-android-checkbox-outline',
        type: 'checkbox',
        name: API.LANG.CHECK_BOX,
      }, {
        icon: 'ion-android-radio-button-on',
        type: 'radio',
        name: API.LANG.RADIO,
      }, {
        icon: 'ion-compose',
        type: 'select',
        name: API.LANG.SELECT,
      }, {
        icon: 'ion-android-list',
        type: 'combobox',
        name: API.LANG.COMBO_BOX,
      }, {
        icon: 'ion-arrow-resize',
        type: 'sizebox',
        name: API.LANG.SIZE_BOX,
      }, {
        icon: 'ion-ios-color-wand-outline',
        type: 'colorbox',
        name: API.LANG.COLOR_BOX,
      }, {
        icon: 'ion-arrow-swap',
        type: 'scrollbox',
        name: API.LANG.SCROLL_BOX,
      }, {
        icon: 'ion-image',
        type: 'imageselect',
        name: API.LANG.IMAGE_SELECT,
      }, {
        icon: 'ion-social-tumblr',
        type: 'text',
        name: API.LANG.TEXT,
      }, {
        icon: 'ion-pricetag',
        type: 'tag',
        name: API.LANG.TAGS,
      }, {
        icon: 'ion-android-options',
        type: 'rangeinput',
        name: API.LANG.RANGE_INPUT,
      }, {
        icon: 'ion-location',
        type: 'mapsearch',
        name: API.LANG.MAP_SEARCH,
      }, {
        icon: 'ion-loop',
        type: 'reset',
        name: API.LANG.RESET,
      }, {
        icon: 'ion-hammer',
        type: 'sidebar',
        name: API.LANG.SIDEBAR,
      }, {
        icon: 'ion-ios-list',
        type: 'linearcheckbox',
        name: API.LANG.LINEARCHECKBOX,
      }, {
        icon: 'ion-calendar',
        type: 'daterange',
        name: API.LANG.DATEPICKER,
      },
    ];
    const isRnB = this.props.settingsData.hasOwnProperty('rnb_active') ? true : false;
    if (isRnB === true) {
      const temp = {
        icon: 'ion-model-s',
        type: 'rnb-daterange',
        name: API.LANG.RNBDATEPICKER,
      };
      this.searchComponents.push(temp);
    }
    this.handleSelected = this.handleSelected.bind(this);
    this.allLayout = [12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1];
    this.addSelected = this.addSelected.bind(this);
    const indexType = findIndex(this.props.allLayout, { uid: this.props.uid });
    if (indexType !== -1) {
      this.state = { styleType: this.props.allLayout[indexType].styleType, showAdvacedOption: false };
    } else {
      this.state = { styleType: null, showAdvacedOption: false };
    }
  }

  handleSelected(e) {
    if (e.target.checked) {
      this.selectedElement = e.target.value;
    }
  }
  addSelected(e) {
    e.preventDefault();
    const allLayout = clone(this.props.allLayout);
    if (this.selectedElement) {
      const find = findIndex(allLayout, { uid: this.props.uid });
      if (find !== -1) {
        if (typeof(allLayout[find].searchAttr) === 'undefined') {
          allLayout[find].searchAttr = [];
        }
        allLayout[find].searchAttr.push({
          'uid': new Date().getTime(),
          'viewType': this.selectedElement,
          'title': this.selectedElement,
        });
      }
      const pushLayout = {
        allLayout,
        'shortcodeKey': this.props.shortcodeKey,
      };
      BuildActions.saveAllBlocks(pushLayout);
      this.props.onClickedPanel();
    }
  }
  render() {
    const showSearchElements = (element, index) => {
      return (<li className="search-content" key={'searchElement-' + index}>
        <input type="radio" name="search-element" id={'search-block-' + index} value={element.type} onChange={this.handleSelected} />
        <label className="select-search-content" htmlFor={'search-block-' + index}>
          <i className={element.icon}></i>
          <span className="search-title">{element.name}</span>
        </label>
      </li>);
    };

    return (<div>
      <div className="for-search-panel">
        <div className="">
          <span className="caption">{API.LANG.SELECT_TYPE}</span>
          <div className="">
            <ul className="list-inline"> {this.searchComponents.map(showSearchElements)}</ul>
          </div>
        </div>
      </div>
      <div className="add-button-content">
       { this.state.errorMsg !== undefined ? <p className="error-body">{this.state.errorMsg}</p> : null }
        <a href="#" className="add-button" onClick={this.addSelected}> {API.LANG.ADD} </a>
      </div>
    </div>);
  }
}

SearchPanel.propTypes = {
  'shortcodeKey': React.PropTypes.number,
  'uid': React.PropTypes.string,
  'allLayout': React.PropTypes.array,
  'onClickedPanel': React.PropTypes.func,
  'settingsData': React.PropTypes.object,
};

export default SearchPanel;



// WEBPACK FOOTER //
// ./assets/src/frontend/panel/searchPanel.js